<template>
	<div style="height: 100%; width: 100%">
		<div style="height: 100%; position: relative" v-if="focusedClient">
			<AttendanceLogEntries />
		</div>
		<div v-else style="text-align: center">
			Kein Klient ausgewählt!
		</div>
		<AddClientAttendanceModal v-model="openModal" />
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import AddClientAttendanceModal from "@/components/modals/AddClientAttendanceModal.vue"
import AttendanceLogEntries from "./AttendanceLogEntries.vue";

export default {
	name: "Attendance",
	components: { AddClientAttendanceModal, AttendanceLogEntries },
	data() {
		return {
			focusedLog: undefined,
		};
	},
	mounted() {
		if (this.$route.params.data) {
			let searchString = this.$route.params.data[0]
			if (this.$route.params.type) {
				searchString = searchString + " " + this.$route.params.type
			}
			this.$store.dispatch("setEntrySearchQuery", searchString);
		}
	},
	destroyed() {
		this.$store.dispatch("setEntrySearchQuery", '');
	},
	computed: {
		...mapGetters({
			focusedClient: "clients/getFocusedClient",
			absenceReasons: "absence/getData",
			presenceReasons: "presence/getData",
		}),
		openModal: {
			get() {
				return this.$store.getters["getAttendanceModalOpen"];
			},
			set(newValue) {
				return this.$store.dispatch("setAttendanceModalOpen", newValue);
			},
		},
	},
	watch: {
		focusedClient(newData) {
			if (!newData) {
				this.$store.dispatch("setEntrySearchQuery", '');
			}
		},
		absenceReasons(newData) {
			newData.forEach(element => {
				var style = document.createElement('style');
				let styleColor = element.attributes.color
				//Punkte und Leerzeichen durch "nichts" ersetzen, sodass ein valider CSS-Classname entsteht
				let styleName = (element.attributes.name.replace(".", '')).replace(/\s/g, "")
				style.type = 'text/css';
				style.innerHTML = '.' + styleName + ' { background-color: ' + styleColor + '; }';
				document.getElementsByTagName('head')[0].appendChild(style);
			});
		},
		presenceReasons(newData) {
			newData.forEach(element => {
				var style = document.createElement('style');
				let styleColor = element.attributes.color
				//Punkte und Leerzeichen durch "nichts" ersetzen, sodass ein valider CSS-Classname entsteht
				let styleName = (element.attributes.name.replace(".", '')).replace(/\s/g, "")
				style.type = 'text/css';
				style.innerHTML = '.' + styleName + ' { background-color: ' + styleColor + '; }';
				document.getElementsByTagName('head')[0].appendChild(style);
			});
		},
	},
};
</script>



<style scoped>
.white-text {
	color: white;
}

.entry-box {
	margin-right: 0.5em;
	margin-left: 0.5em;
	cursor: pointer;
	padding-bottom: 15px;
}

.entry-box:hover {
	background-color: whitesmoke;
}

.scrollable {
	overflow: auto;
	height: 100%;
	width: 100%;
	padding-bottom: 1.5rem;
}

.article {
	width: 100%;
	border-radius: 0.5rem;
}

.entry-box-entry {
	margin-right: 0.5em;
	margin-left: 0.5em;
	padding-bottom: 15px;
	text-align: center;
}

@media (max-width: 1026px) {
	.scrollable {
		overflow: auto;
		height: 100%;
		width: 100%;
	}
}

@media (max-width: 769px) {

	.tabs:not(:last-child),
	.pagination:not(:last-child),
	.message:not(:last-child),
	.level:not(:last-child),
	.breadcrumb:not(:last-child),
	.block:not(:last-child),
	.title:not(:last-child),
	.subtitle:not(:last-child),
	.table-container:not(:last-child),
	.table:not(:last-child),
	.progress:not(:last-child),
	.progress-wrapper.is-not-native:not(:last-child),
	.notification:not(:last-child),
	.content:not(:last-child),
	.box:not(:last-child) {
		margin-bottom: 0;
	}

	.scrollable {
		height: 100%;
		width: 95vw;
	}

	.entry-box {
		display: flex;
		width: 96%;
	}
}

@media (max-width: 400px) {
	div.media-left {
		margin: 0.1em 0 0 0;
	}
}

@media (max-width: 450px) {
	.authorTagContainer {
		display: flex;
		flex-direction: row;
		align-items: start;
	}

	.iconContainer {
		justify-content: start !important;
		display: flex !important;
		flex-direction: row !important;
	}
}
</style>
